"use client";

import {
  Box,
  Typography,
  Container,
  Card,
  CardContent,
  Button,
  Avatar,
  useTheme,
} from "@mui/material";
import { tokens } from "../../../theme";
import benefitsimage from "../assets/benefits.png";

const benefits = [
  {
    number: 1,
    title: "Earn Extra Income",
    description: "Receive commissions with no extra workload",
  },
  {
    number: 2,
    title: "Earn Extra Income",
    description: "Receive commissions with no extra workload",
  },
  {
    number: 3,
    title: "Earn Extra Income",
    description: "Receive commissions with no extra workload",
  },
];

interface BenefitsProps {
  onBecomePartner: () => void;
}

function BenefitCard({
  number,
  title,
  description,
}: {
  number: number;
  title: string;
  description: string;
}) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Card
      sx={{
        borderRadius: "22px",
        border: "1px solid #6D4C41",
        boxShadow: "0 ",
        backgroundColor: colors.primary[900],
        height: 300,
      }}
    >
      <CardContent sx={{ p: { xs: 3, md: 3.5 } }}>
        <Avatar
          variant="rounded"
          sx={{
            width: 54,
            height: 54,
            borderRadius: "16px",
            backgroundColor: "#6D4C41",
            color: "#fff",
            fontWeight: 900,
            fontSize: "1.2rem",
            mb: 2.2,
          }}
        >
          {number}
        </Avatar>

        <Typography
          sx={{
            fontWeight: 900,
            color: "#5A3C34",
            mb: 0.9,
            fontSize: "1.05rem",
          }}
        >
          {title}
        </Typography>

        <Typography
          sx={{ color: "#6F4F46", lineHeight: 1.6, fontSize: "0.95rem" }}
        >
          {description}
        </Typography>
      </CardContent>
    </Card>
  );
}

export default function Benefits({ onBecomePartner }: BenefitsProps) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Box
      sx={{
        py: { xs: 6, md: 10 },
        backgroundColor: colors.primary[900],
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          opacity: 0.12,
          backgroundImage:
            "radial-gradient(circle at 85% 20%, rgba(62,39,35,0.25) 0 2px, transparent 2px)," +
            "radial-gradient(circle at 25% 80%, rgba(62,39,35,0.25) 0 2px, transparent 2px)",
          backgroundSize: "180px 180px",
          pointerEvents: "none",
        }}
      />

      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "360px 1fr" },
            gap: { xs: 3, md: 4 },
            alignItems: "start",
          }}
        >
          {/* LEFT IMAGE TILE */}
          <Box
            sx={{
              position: "relative",
              borderRadius: "26px",
              overflow: "hidden",
              minHeight: { xs: 360, md: 620 },
              backgroundImage: `url(${benefitsimage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              boxShadow: "0 18px 40px rgba(62,39,35,0.12)",
            }}
          >
            {/* dark bottom fade */}
            <Box
              sx={{
                position: "absolute",
                inset: 0,
                background:
                  "linear-gradient(180deg, rgba(0,0,0,0) 45%, rgba(62,39,35,0.75) 100%)",
              }}
            />
            <Box
              sx={{
                position: "absolute",
                left: 22,
                bottom: 22,
                right: 22,
              }}
            >
              <Typography
                sx={{
                  color: "#fff",
                  fontWeight: 900,
                  fontSize: { xs: "2rem", md: "2.3rem" },
                  lineHeight: 1.05,
                }}
              >
                Benefits of <br />
                becoming a <br />
                partner
              </Typography>
            </Box>
          </Box>

          {/* RIGHT 2x2 GRID (exact screenshot layout) */}
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
              gridTemplateRows: { xs: "auto", sm: "auto auto" },
              gap: { xs: 2.5, md: 3 },
            }}
          >
            {/* top-left */}
            <BenefitCard {...benefits[0]} />

            {/* top-right */}
            <BenefitCard {...benefits[1]} />

            {/* bottom-left CTA tile */}
            <Card
              sx={{
                borderRadius: "22px",
                backgroundColor: "#6D4C41",
                boxShadow: "0 18px 40px rgba(62,39,35,0.16)",
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "center",
                minHeight: { xs: 170, md: 210 },
              }}
            >
              <CardContent sx={{ pb: 3.5 }}>
                <Button
                  variant="outlined"
                  onClick={onBecomePartner}
                  sx={{
                    borderColor: "rgba(255,255,255,0.85)",
                    color: "#fff",
                    borderRadius: "999px",
                    px: 5,
                    py: 1.2,
                    textTransform: "none",
                    fontWeight: 800,
                    "&:hover": {
                      borderColor: "#fff",
                      backgroundColor: "rgba(255,255,255,0.12)",
                    },
                  }}
                >
                  Become a Partner
                </Button>
              </CardContent>
            </Card>

            {/* bottom-right */}
            <BenefitCard {...benefits[2]} />
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
